const R = 6371e3; // metres

function normalizeStart(a) {
  let newData = [];

  // Normalizing the first survey
  newData.push(a[0]);

  // Normalizing the next surveys to the first
  if (a.length > 1) {
    for (let i = 1; i < a.length; i++) {
      newData.push(normalizeData(a[i], newData[0].normalizedData));
    }
  }

  return newData;
}

function normalizeData(d, firstScan = null) {
  // console.log(firstScan);
  let scans = [];

  // d.scans.forEach(scan => {
  //   scans.push(JSON.parse(JSON.stringify(scan.readings)));
  // });

  // if (scans[0].length < 1) {
  //   scans = [[d.normalizedData]];
  // }
  scans = [d.normalizedData];

  // If there is two surveys
  if (firstScan != null) {
    for (let i = 0; i < scans.length; i++) {
      scans[i] = insertFillerData(scans[i], firstScan);
    }
  }

  let setNormalizedData = false;

  if (scans.length > 1 || firstScan != null) {
    let sp = firstScan ? firstScan[0] : getStartingPosition(scans);
    let ep = firstScan
      ? firstScan[firstScan.length - 1]
      : getEndingPosition(scans);
    let trimmedData = trimDataToStartAndEnd(scans, sp, ep);
    let normalizedData = getNormalizedData(trimmedData, firstScan);
    for (let i = 0; i < d.scans.length; i++) {
      d.scans[i].readings = normalizedData[i];
    }
    d.normalizedData = normalizedData[0];
    setNormalizedData = true;
  } else {
    d.scans[0].readings = scans[0];
  }
  d.normalizedData = setNormalizedData ? d.normalizedData : scans[0];

  return d;
}

// *************
// Second Survey Filler
// *************

function insertFillerData(scan, firstScan, reverse = false) {
  let points = getStartingAndEndingPointWithBase(scan, firstScan);

  // Checking if the scan is the wrong way around
  if (points.ep < points.sp && reverse) {
    scan.reverse();
    let ep = JSON.parse(JSON.stringify(points.ep));
    points.ep = JSON.parse(JSON.stringify(points.sp));
    points.sp = ep;
  }

  if (points.sp != 0 && (points.sp < firstScan.length / 2 || reverse)) {
    let newArray = [];
    for (let i = 0; i < points.sp; i++) {
      let data = JSON.parse(JSON.stringify(firstScan[i]));
      data.value = "0";
      data.hideCircle = true;
      newArray.push(data);
    }
    scan = [...newArray, ...scan];
  }

  if (
    points.ep != firstScan.length - 1 &&
    (points.ep > firstScan.length / 2 || reverse)
  ) {
    let newArray = [];
    for (let i = points.ep + 1; i < firstScan.length - 1; i++) {
      let data = JSON.parse(JSON.stringify(firstScan[i]));
      data.value = "0";
      data.hideCircle = true;
      newArray.push(data);
    }
    scan = [...scan, ...newArray];
  }

  return scan;
}

function getStartingAndEndingPointWithBase(scan, firstScan) {
  let sp = 0;
  let ep = scan.length;

  let currentSPDistance = getDistanceBetweenPointAPointB(scan[0], firstScan[0]);
  let currentEPDistance = getDistanceBetweenPointAPointB(scan[0], firstScan[0]);

  // Getting the index from First scan that is closest to Starting Point(SP) and Ending Point (EP)
  for (let i = 0; i < firstScan.length; i++) {
    let spd = getDistanceBetweenPointAPointB(scan[0], firstScan[i]);
    let epd = getDistanceBetweenPointAPointB(
      scan[scan.length - 1],
      firstScan[i]
    );

    if (spd < currentSPDistance) {
      currentSPDistance = spd;
      sp = i;
    }

    if (epd < currentEPDistance) {
      currentEPDistance = epd;
      ep = i;
    }
  }

  return {
    sp: sp,
    ep: ep
  };
}

// *************
// GET START POS
// *************

function getStartingPosition(d) {
  let startingPosition = null;

  for (let i = 0; i < d.length - 1; i++) {
    startingPosition = getStartPositionWithComparison(
      startingPosition != null ? [startingPosition] : d[i],
      d[i + 1]
    );
  }

  return startingPosition;
}

function getStartPositionWithComparison(a1, a2) {
  let d1 = getDistanceBetweenPointAPointB(a1[0], a2[0]);
  let d2 = getDistanceBetweenPointAPointB(a1[0], a2[1]);

  return d2 > d1 ? a2[0] : a1[0];
}

// *************
// GET END POS
// *************

function getEndingPosition(d) {
  let endingPosition = null;
  for (let i = 0; i < d.length - 1; i++) {
    endingPosition = getEndingPositionWithComparison(
      endingPosition != null ? [endingPosition] : d[i],
      d[i + 1]
    );
  }
  return endingPosition;
}

function getEndingPositionWithComparison(a1, a2) {
  let d1 = getDistanceBetweenPointAPointB(a1[a1.length - 1], a2[a2.length - 1]);
  let d2 = getDistanceBetweenPointAPointB(a1[a1.length - 1], a2[a2.length - 2]);

  return d2 > d1 ? a2[a2.length - 1] : a1[a1.length - 1];
}

// *************
// GET TRIMMED
// *************

function trimDataToStartAndEnd(d, sp, ep) {
  let data = [];
  for (let i = 0; i < d.length; i++) {
    let si = getStartingIndex(d[i], sp);
    let ei = getEndingIndex(d[i], ep);
    d[i].splice(d[i].length - 1, d[i].length - 1 - ei);
    d[i].splice(0, si);
    data.push(d[i]);
  }
  return data;
}

function getStartingIndex(a, sp) {
  let spFound = false;
  let i = 0;
  while (!spFound) {
    let d1 = getDistanceBetweenPointAPointB(sp, a[i]);
    let d2 = getDistanceBetweenPointAPointB(sp, a[i + 1]);

    spFound = d1 > d2 ? false : true;
    i = spFound ? i : i + 1;
  }
  return i;
}

function getEndingIndex(a, ep) {
  let epFound = false;
  let i = a.length - 1;
  while (!epFound) {
    let d1 = getDistanceBetweenPointAPointB(ep, a[i]);
    let d2 = getDistanceBetweenPointAPointB(ep, a[i - 1]);

    epFound = d1 > d2 ? false : true;
    i = epFound ? i : i - 1;
  }
  return i;
}

// *************
// GET NORMALIZED
// *************

function getNormalizedData(d, base = null) {
  let data = [];

  if (base == null) {
    d.forEach(a => {
      base = base == null ? a : a.length < base.length ? a : base;
    });
  }

  // console.log(base);

  for (let i = 0; i < d.length; i++) {
    data.push(normalizeArray(d[i], base));
  }

  return data;
}

function lowfiPoints(points, minDistance) {
  let previousPoint = points[0];
  let newPoints = [];

  newPoints.push(previousPoint);

  for (const point of points) {
    let distance = getDistanceBetweenPointAPointB(previousPoint, point);
    if (distance > minDistance) {
      previousPoint = point;
      newPoints.push(point);
    }
  }

  return newPoints;
}

function normalizeArray(a, b) {
  let data = [];
  let i = 0;
  b.forEach(point => {
    let pFound = false;
    while (!pFound) {
      // console.log(a[i]);
      let d1 = getDistanceBetweenPointAPointB(point, a[i]);
      let d2 = getDistanceBetweenPointAPointB(point, a[i + 1]);
      pFound = d1 > d2 && i != a.length - 2 ? false : true;
      i = pFound ? i : i + 1;
    }
    data.push(a[i]);
    if (i != a.length - 2) {
      // i -= 2;
    }
  });
  return data;
}

// *************
// GENERAL
// *************

function getDistanceBetweenPointAPointB(a1, a2) {
  const φ1 = (a1.lat * Math.PI) / 180; // φ, λ in radians
  const φ2 = (a2.lat * Math.PI) / 180;
  const Δφ = ((a2.lat - a1.lat) * Math.PI) / 180;
  const Δλ = ((a2.lng - a1.lng) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const d = R * c; // in metres
  return d;
}

export { normalizeStart, R };
